"use client";

import { Button } from "@/components/ui/buttons/Button";
import { Icon } from "@/components/v2/ui/icons/Icon";
import { PageTitle } from "@/components/ui/text-types/PageTitle";
import Link from "next/link";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-secondary dark:bg-dark-background-primary">
      <div className="max-w-md w-full bg-background-secondary dark:bg-dark-background-primary rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-primary/15 mb-4">
            <Icon name="not-found" variant="outline" size={32} />
          </div>
          <PageTitle title="Page not found" />
          <p className="text-6xl font-semibold text-text-disabled dark:text-dark-text-disabled mt-2">
            404
          </p>
        </div>

        <div className="mb-8">
          <p className="text-subtext dark:text-dark-subtext mb-4">
            The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </p>
          <p className="text-sm text-subtext dark:text-dark-subtext">
            Check the URL or go back to the home page to get started.
          </p>
        </div>

        <div className="space-y-3">
          <Link
            href="/"
            className="inline-flex justify-center w-full rounded-md border border-border dark:border-dark-border bg-background-secondary dark:bg-dark-background-primary px-2 py-1.5 text-sm font-medium text-text dark:text-dark-text hover:bg-background-secondary dark:hover:bg-dark-background-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 h-8"
          >
            Go home
          </Link>

          <Button
            variant="default"
            onClick={() => window.history.back()}
            className="w-full"
          >
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}
